export function deepNestedSearch(hay, needle, accumulator?) {
    var accumulator = accumulator || [];
    if (typeof hay === 'object') {
      for (var i in hay) {
        deepNestedSearch(hay[i], needle, accumulator) == true ? accumulator.push(hay) : 1;
      }
    }
    return new RegExp(needle).test(hay) || accumulator;
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/search.ts